import React, { Component } from 'react';
import { formValueSelector, reduxForm } from 'redux-form'

import Login from './loginComponent'
import { actions } from '../login'
import { connect } from 'react-redux'
import qs from 'qs' // https://github.com/ljharb/qs

class Wrapper extends Component {
    componentDidMount() {             
        if (this.props.match.path === '/bcc_login') {
            this.props.loginBcc();
        }

        this.props.fetchSSOLink();

        const parsed = qs.parse(this.props.location.search.substring(1));    
        this.props.loadDetails(parsed);
    }
    render() {
        return (
            <Login {...this.props} />
        )
    }
}

const selector = formValueSelector('LoginForm');

const mapStateToProps = (state, ownProps) => {    
    return {
        initialValues: state.waas.login.initialValues,
        pid: selector(state, 'pid'),
        vid: selector(state, 'vid'),
        loading: state.waas.login.loading,
        errors: state.waas.login.errors,
        loginURL:state.waas.login.loginURL,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadDetails: (params) => {
            dispatch(actions.loadDetails(params))
        },           
        loginBcc: () => {
            dispatch(actions.loginBcc())
        },
        fetchSSOLink: () => {
            dispatch(actions.fetchSSOLink())
        },
    }
}


const onSubmit = (values, dispatch) => {   // reduxForm onChange    
    return new Promise((resolve, reject) => {
        if (values.type === 'signIn') {
            dispatch(actions.login(values, reject, resolve))    
        } else {
            //dispatch(actions.submit(props.waasId, values, reject, resolve))
        }        
    })
}


const withForm = reduxForm({
    form: 'LoginForm',
    onSubmit,
    enableReinitialize: true,
})(Wrapper)

export default connect(mapStateToProps, mapDispatchToProps)(withForm)